<template>
    <div className="w-full h-screen flex">
        <!-- <div class="text-[18px] flex items-center justify-between font-light p-4 text-black text-center">
            <button v-on:click="btnAction('des')" class="rounded-lg px-12 text-[16px] py-1 border">Prev</button>
            <span>Ordre de mission</span>
            <button v-on:click="btnAction('asc')" class="rounded-lg px-12 text-[16px] py-1 border">Next</button>
        </div> -->
        <!-- <div class="border-y p-4 flex items-center justify-evenly text-black">
            <div :class="['size-14 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 1}]" v-on:click="step = 1">1</div>
            <div class="h-[1px] w-[120px] bg-gray-100"/>
            <div :class="['size-14 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 2}]" v-on:click="step = 2">2</div>
            <div class="h-[1px] w-[120px] bg-gray-100"/>
            <div :class="['size-14 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 3}]" v-on:click="step = 3">3</div>
            <div class="h-[1px] w-[120px] bg-gray-100"/>
            <div :class="['size-14 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 4}]" v-on:click="step = 4">4</div>
            <div class="h-[1px] w-[120px] bg-gray-100"/>
            <div :class="['size-14 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 5}]" v-on:click="step = 5">5</div>
        </div> -->
        <!-- <form @submit.prevent="submitRequest" class="p-4 text-black">
            <div v-if="step == 1">
                <h2 class="text-[22px] font-light mb-[12px] underline px-6">Missionnaire </h2>
                <p>Information relatif à la personne qui part en mission</p>
                <div class="flex items-center justify-between px-6">
                    <span>Voyageur</span>
                    <div class="flex items-center gap-x-3">
                        <input type="radio" id="trip1" name="trip" value="yourself" />
                        <label for="trip1">Moi-meme</label>

                        <input type="radio" id="trip2" name="trip" value="colleague" />
                        <label for="trip2">Collegue</label>

                        <input type="radio" id="trip3" name="trip" value="customer" />
                        <label for="trip3">Client</label>
                    </div>
                </div>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Prenom<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Fonction<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Mail<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Document de voyage<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Numéro<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Date d'émission<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Date d'expiration<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Nationalité<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Genre<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Date de naissance<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Lieu de naissance<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Lieu de résidence habituelle<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>
                </div>
            </div>

            <div v-else-if="step == 2">
                <h2 class="text-[22px] font-light mb-[12px] underline">Circuit et Objet de la mission</h2>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Ville de départ<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >horaire<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Ville d'arrivé<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >horaire<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Ville de départ<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >horaire<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Ville d'arrivée<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >horaire<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Motif de la mission<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>
                </div>

                <div class="flex items-center justify-between">
                    <span>Moyen de transport</span>
                    <div class="flex items-center gap-x-3">
                        <input type="radio" id="trip1" name="trip" value="yourself" />
                        <label for="trip1">Véhicule de service</label>

                        <input type="radio" id="trip2" name="trip" value="colleague" />
                        <label for="trip2">Transport Publique</label>

                        <input type="radio" id="trip3" name="trip" value="customer" />
                        <label for="trip3">Transport Aérien</label>

                        <input type="radio" id="trip3" name="trip" value="customer" />
                        <label for="trip3">Transport Ferroviaire</label>
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Immatriculation<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Proprietaire<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Marque<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Couleur<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="flex items-center justify-between">
                    <span>Visa requis</span>
                    <div class="flex items-center gap-x-3">
                        <input type="radio" id="trip1" name="trip" value="yourself" />
                        <label for="trip1">Oui</label>

                        <input type="radio" id="trip2" name="trip" value="colleague" />
                        <label for="trip2">Non</label>
                    </div>
                </div>
            </div>

            <div v-else-if="step == 3">
                <h2 class="text-[22px] font-light mb-[12px] underline">Moyen de Transport</h2>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Hébergement<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Transport<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Per Diem<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Actions Business<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Autres<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Monnaie<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Total<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>
                </div>
            </div>

            <div v-else-if="step == 4">
                <h2 class="text-[22px] font-light mb-[12px] underline">Autres Services Requis</h2>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Superviseur/Manager<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Copier à<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="name" class="font-light" >Ligne budgétaire<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                    </div>

                    <div class="w-[49%] flex flex-col items-start ">
                        <label for="lastname" class="font-light" >Validateur Final<span class="text-[#f44545]">*</span></label>
                        <input type="text" placeholder="Doe" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                    </div>
                </div>
            </div>

            <div v-else></div>
            
            <div class="w-full px-6 mt-6">
                <button type="submit" :disabled="asSend" class="w-full mx-auto py-3 bg-[#5357ec] text-white rounded-md">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Soumettre</span>
                </button>
            </div>
        </form> -->
        <div class="bg-gray-50 h-full w-[25%] p-6">
            <div class="flex flex-col items-start gap-y-3 text-[#5357ec]">
                <div class="flex items-center gap-x-6">
                    <div :class="['size-10 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 1}]" v-on:click="step = 1">1</div>
                    <h2 class="font-light">Information personnel</h2>
                </div>
                <div class="h-[16px] w-5 border-r border-dashed"/>

                <div class="flex items-center gap-x-6">
                    <div :class="['size-10 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 2}]" v-on:click="step = 2">2</div>
                    <h2 class="font-light">Circuit et Objet de la mission</h2>
                </div>
                <div class="h-[16px] w-5 border-r border-dashed"/>

                <div class="flex items-center gap-x-6">
                    <div :class="['size-10 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 3}]" v-on:click="step = 3">3</div>
                    <h2 class="font-light">Moyen de Transport</h2>
                </div>
                <div class="h-[16px] w-5 border-r border-dashed"/>

                <div class="flex items-center gap-x-6">
                    <div :class="['size-10 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 4}]" v-on:click="step = 4">4</div>
                    <h2 class="font-light">Visa</h2>
                </div>
                <div class="h-[16px] w-5 border-r border-dashed"/>

                <div class="flex items-center gap-x-6">
                    <div :class="['size-10 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 5}]" v-on:click="step = 5">5</div>
                    <h2 class="font-light">Autres Services Requis</h2>
                </div>
                <div class="h-[16px] w-5 border-r border-dashed"/>

                <div class="flex items-center gap-x-6">
                    <div :class="['size-10 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 6}]" v-on:click="step = 6">6</div>
                    <h2 class="font-light">Budget Estimatif</h2>
                </div>
                <div class="h-[16px] w-5 border-r border-dashed"/>

                <div class="flex items-center gap-x-6">
                    <div :class="['size-10 rounded-full border border-[#5357ec] flex items-center justify-center cursor-pointer',{'bg-[#5357ec] text-white':step >= 7}]" v-on:click="step = 7">7</div>
                    <h2 class="font-light">Validation</h2>
                </div>
            </div>
        </div>
        <div class="grow flex justify-center relative overflow-y-scroll">
            <h1 class="absolute left-6 top-6 text-[18px] font-light underline">Formulaire d'ordre de mission</h1>
            <X v-on:click="pushdemande" :size="18" class="absolute top-3 right-3 cursor-pointer" />
            <div class="w-[55%] p-8">
                <div class="h-[100px] w-full"/>
                <div v-if="step == 1" class="w-full flex flex-col gap-y-5">
                    <h2 class="text-[17px]">Information relatif à la personne qui part en mission</h2>
                    <p class="w-full rounded-xl p-4 bg-[#eeeefe] flex items-center gap-x-3 font-extralight">
                        <Info :size="18"/>
                        <span>Veuillez remplir tout les champs avec l'indice (*)</span>
                    </p>

                    <div>
                        <p class="text-[16px] font-light">Sélectionner la personne qui part en mission</p>
                        <div class="flex items-center gap-x-8 mt-5">
                            <div class="rounded-3xl border px-4 pb-2 pt-3">
                                <input type="radio" id="trip1" name="trip" value="yourself" />
                                <label for="trip1" class="font-light">Moi-meme</label>
                            </div>

                            <div class="rounded-3xl border px-4 pb-2 pt-3">
                                <input type="radio" id="trip2" name="trip" value="colleague" />
                                <label for="trip2" class="font-light">Collegue</label>
                            </div>

                            <div class="rounded-3xl border px-4 pb-2 pt-3">
                                <input type="radio" id="trip3" name="trip" value="customer" />
                                <label for="trip3" class="font-light">Client</label>
                            </div>
                        </div>
                    </div>

                    <p class="text-[16px] font-light flex items-center gap-x-6">
                        <User :size="18"/>
                        Détails voyageur</p>

                    <div class="flex flex-col gap-y-2">
                        <label for="name" class="font-light">Nom légale<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Nom">
                        <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Prenom">
                    </div>

                    <div class="grid grid-cols-2 gap-x-5">
                        <div class="flex flex-col">
                            <label for="name" class="font-light">Email<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="jhone@gmail.com">
                        </div>

                        <div class="flex flex-col">
                            <label for="name" class="font-light">Telephone<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="XXX XXXXXX">
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <label for="name" class="font-light">Fonction<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Commercial">
                    </div>

                    <div class="grid grid-cols-2 gap-x-5">
                        <div class="flex flex-col">
                            <label for="name" class="font-light">Document de voyage<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Passeport">
                        </div>

                        <div class="flex flex-col">
                            <label for="name" class="font-light">Numéro<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="XXX XXXXXX">
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-x-5">
                        <div class="flex flex-col">
                            <label for="name" class="font-light">Date d'émission<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                        </div>

                        <div class="flex flex-col">
                            <label for="name" class="font-light">Date d'expiration<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <label for="name" class="font-light">Nationalité<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Ivoirienne">
                    </div>

                    <div class="grid grid-cols-2 gap-x-5">
                        <div class="flex flex-col">
                            <label for="name" class="font-light">Date de naissance<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                        </div>

                        <div class="flex flex-col">
                            <label for="name" class="font-light">Lieu de naissance<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="XXX XXXXXX">
                        </div>
                    </div>
                    
                </div>
                <div v-else-if="step == 2" class="w-full flex flex-col gap-y-5">
                    <h2 class="text-[17px]">Circuit et Objet de la mission</h2>
                     <p class="w-full rounded-xl p-4 bg-[#eeeefe] flex items-center gap-x-3 font-extralight">
                        <Info :size="18"/>
                        <span>Veuillez remplir tout les champs avec l'indice (*)</span>
                    </p>

                    <p class="text-[16px] font-light flex items-center gap-x-6">
                        Aller</p>

                    <div class="grid grid-cols-2 gap-x-5">
                        <div class="flex flex-col">
                            <label for="name" class="font-light">Ville de départ<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Abidjan">
                        </div>

                        <div class="flex flex-col">
                            <label for="name" class="font-light">Horaire<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-x-5">
                        <div class="flex flex-col">
                            <label for="name" class="font-light">Ville d'arrivée"<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Paris">
                        </div>

                        <div class="flex flex-col">
                            <label for="name" class="font-light">Horaire<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                        </div>
                    </div>

                    <p class="text-[16px] font-light flex items-center gap-x-6">
                        Retour</p>
                    
                    <div class="grid grid-cols-2 gap-x-5">
                        <div class="flex flex-col">
                            <label for="name" class="font-light">Ville de départ<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Paris">
                        </div>

                        <div class="flex flex-col">
                            <label for="name" class="font-light">Horaire<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-x-5">
                        <div class="flex flex-col">
                            <label for="name" class="font-light">Ville d'arrivée"<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Abidjan">
                        </div>

                        <div class="flex flex-col">
                            <label for="name" class="font-light">Horaire<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <label for="name" class="font-light">Motif de la mission<span class="text-[#f44545]">*</span></label>
                        <textarea name="name" class="h-[130px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Détail"></textarea>
                    </div>
                </div>
                <div v-else-if="step == 3" class="w-full flex flex-col gap-y-5">
                    <h2 class="text-[17px]">Moyen de Transport</h2>
                    <p class="w-full rounded-xl p-4 bg-[#eeeefe] flex items-center gap-x-3 font-extralight">
                        <Info :size="18"/>
                        <span>Veuillez remplir tout les champs avec l'indice (*)</span>
                    </p>
                    <div>
                        <p class="text-[16px] font-light">Sélectionner le moyen de transport</p>
                        <div class="flex items-center gap-x-8 mt-5">
                            <div class="rounded-3xl border px-4 pb-2 pt-3">
                                <input type="radio" id="trip1" name="trip" value="yourself" />
                                <label for="trip1" class="font-light">Véhicule de Service</label>
                            </div>

                            <div class="rounded-3xl border px-4 pb-2 pt-3">
                                <input type="radio" id="trip2" name="trip" value="colleague" />
                                <label for="trip2" class="font-light">Transport Publique</label>
                            </div>

                            <div class="rounded-3xl border px-4 pb-2 pt-3">
                                <input type="radio" id="trip3" name="trip" value="customer" />
                                <label for="trip3" class="font-light">Transport Aérien</label>
                            </div>

                            <div class="rounded-3xl border px-4 pb-2 pt-3">
                                <input type="radio" id="trip3" name="trip" value="customer" />
                                <label for="trip3" class="font-light">Transport Ferroviaire</label>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-y-5 p-6 rounded-2xl bg-gray-50">
                        <div class="flex flex-col">
                            <label for="name" class="font-light">Numéro d'immatriculation<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="XXXXXXXX">
                        </div>
                        <div class="flex flex-col">
                            <label for="name" class="font-light">Agent Propriétaire du véhicule (personnel)<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Koffi">
                        </div>

                        <div class="grid grid-cols-2 gap-x-5">
                            <div class="flex flex-col">
                                <label for="name" class="font-light">Marque<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="BMW">
                            </div>

                            <div class="flex flex-col">
                                <label for="name" class="font-light">Couleur<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Rouge">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="step == 4" class="w-full flex flex-col gap-y-5">
                    <h2 class="text-[17px]">Visa</h2>
                    <p class="w-full rounded-xl p-4 bg-[#eeeefe] flex items-center gap-x-3 font-extralight">
                        <Info :size="18"/>
                        <span>Veuillez remplir tout les champs avec l'indice (*)</span>
                    </p>
                    <div>
                        <p class="text-[16px] font-light">Avez-vous besoin d'un Visa?</p>
                        <div class="flex items-center gap-x-8 mt-5">
                            <div class="rounded-3xl border px-4 pb-2 pt-3">
                                <input type="radio" id="trip1" name="trip" value="yourself" />
                                <label for="trip1" class="font-light">Oui</label>
                            </div>

                            <div class="rounded-3xl border px-4 pb-2 pt-3">
                                <input type="radio" id="trip3" name="trip" value="customer" />
                                <label for="trip3" class="font-light">Non</label>
                            </div>
                        </div>

                        <div class="flex mt-5 flex-col gap-y-5 p-6 rounded-2xl bg-gray-50">
                            <div class="flex flex-col">
                                <label for="name" class="font-light">Entité Emettrice<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Vfs">
                            </div>
                            <div class="flex flex-col">
                                <label for="name" class="font-light">Pays/ville<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Koffi">
                            </div>

                            <div class="grid grid-cols-2 gap-x-5">
                                <div class="flex flex-col">
                                    <label for="name" class="font-light">Début séjour<span class="text-[#f44545]">*</span></label>
                                    <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                                </div>

                                <div class="flex flex-col">
                                    <label for="name" class="font-light">Fin séjour<span class="text-[#f44545]">*</span></label>
                                    <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                            </div>
                            </div>
                            <div class="flex flex-col">
                                    <label for="name" class="font-light">Motif de l'invitation<span class="text-[#f44545]">*</span></label>
                                    <textarea name="name" class="h-[130px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder=""></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="step == 5" class="w-full flex flex-col gap-y-5">
                    <h2 class="text-[17px]">Autres Services Requis</h2>
                    <p class="w-full rounded-xl p-4 bg-[#eeeefe] flex items-center gap-x-3 font-extralight">
                        <Info :size="18"/>
                        <span>Veuillez remplir tout les champs avec l'indice (*)</span>
                    </p>

                    <p class="text-[16px] font-light">Attendnace</p>

                    <div class="flex flex-col gap-y-5 p-6 rounded-2xl bg-gray-50">
                        <div class="grid grid-cols-2 gap-x-5">
                            <div class="flex flex-col">
                                <label for="name" class="font-light">Date de début<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                            </div>

                            <div class="flex flex-col">
                                <label for="name" class="font-light">Heure de début<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                            </div>
                        </div>

                        <div class="grid grid-cols-2 gap-x-5">
                            <div class="flex flex-col">
                                <label for="name" class="font-light">Date de fin<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                            </div>

                            <div class="flex flex-col">
                                <label for="name" class="font-light">Heure de fin<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                            </div>
                        </div>

                    </div>

                    <p class="text-[16px] font-light">Billet d'avion/Train/Bus</p>

                    <div class="flex flex-col gap-y-5 p-6 rounded-2xl bg-gray-50">
                        <div>
                            <div class="flex items-center gap-x-8 mt-5">
                                <div class="rounded-3xl border px-4 pb-2 pt-3">
                                    <input type="radio" id="trip1" name="trip" value="yourself" />
                                    <label for="trip1" class="font-light">Aller simple</label>
                                </div>

                                <div class="rounded-3xl border px-4 pb-2 pt-3">
                                    <input type="radio" id="trip2" name="trip" value="colleague" />
                                    <label for="trip2" class="font-light">Aller-Retour</label>
                                </div>

                                <div class="rounded-3xl border px-4 pb-2 pt-3">
                                    <input type="radio" id="trip3" name="trip" value="customer" />
                                    <label for="trip3" class="font-light">Destination Multiple</label>
                                </div>
                            </div>
                        </div>

                        <div class="grid grid-cols-2 gap-x-5">
                            <div class="flex flex-col">
                                <label for="name" class="font-light">Validité du billet<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                            </div>

                            <div class="flex flex-col">
                                <label for="name" class="font-light">Date de départ<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                            </div>
                        </div>

                        <div class="grid grid-cols-2 gap-x-5">
                            <div class="flex flex-col">
                                <label for="name" class="font-light">De<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                            </div>

                            <div class="flex flex-col">
                                <label for="name" class="font-light">A<span class="text-[#f44545]">*</span></label>
                                <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                            </div>
                        </div>

                        <div class="flex flex-col">
                            <label for="name" class="font-light">Billet de classe<span class="text-[#f44545]">*</span></label>
                            <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Commercial">
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <label for="name" class="font-light">Hébergement<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Commercial">
                    </div>

                    <div class="flex flex-col">
                        <label for="name" class="font-light">Demande de véhicule en ligne<span class="text-[#f44545]">*</span></label>
                        <input type="text" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="Commercial">
                    </div>
                </div>
                <div v-else-if="step == 6" class="w-full flex flex-col gap-y-5">
                    <h2 class="text-[17px]">Budget Estimatif</h2>
                    <p class="w-full rounded-xl p-4 bg-[#eeeefe] flex items-center gap-x-3 font-extralight">
                        <Info :size="18"/>
                        <span>Veuillez remplir tout les champs avec l'indice (*)</span>
                    </p>
                </div>
                <div v-else-if="step == 7" class="w-full flex flex-col gap-y-5">
                    <h2 class="text-[17px]">Validation</h2>
                    <p class="w-full rounded-xl p-4 bg-[#eeeefe] flex items-center gap-x-3 font-extralight">
                        <Info :size="18"/>
                        <span>Veuillez remplir tout les champs avec l'indice (*)</span>
                    </p>
                </div>
                <div class="flex items-center justify-between mt-5">
                    <button v-on:click="btnAction('des')" class="rounded-xl px-12 text-[16px] py-3 border">Prev</button>
                    <button v-on:click="btnAction('asc')" class="rounded-xl px-12 text-[16px] py-3 border bg-[#5357ec] text-white">{{step == 7 ? "Soumettre" : "Continuer"}}</button>
                </div>
                <div class="h-[100px] w-full"/>
            </div>
        </div>
    </div>
</template>
<script>
import API from '@/service/API';
import Swal from 'sweetalert2';
import {
    // Loader2
    X,Info,User
} from "lucide-vue-next";
    export default {
        name: "OrdreDeMission",
        components: {X,Info,User},
        data(){
            return {
                asSend:false,
                step:1,
                motif:"",
                type:"",
                formdata:{
                    attendance_required:"",
                    attendance_start_date:"",
                    attendance_end_date:"",
                    attendance_start_time:"",
                    attendance_end_time:"",
                    attendance_total_hours:"",
                    attendance_total_days:"",
                    travel_document_type:"",
                    travel_document_number:"",
                    travel_document_issued_at:"",
                    travel_document_expires_at:"",
                    trip_go_departure_city:"",
                    trip_go_departure_datetime:"",
                    trip_go_arrival_city:"",
                    trip_go_arrival_datetime:"",
                    trip_return_departure_city:"",
                    trip_return_departure_datetime:"",
                    trip_return_arrival_city:"",
                    trip_return_arrival_datetime:"",
                    trip_reason:"",
                    transport_mode:"",
                    vehicle_registration_number:"",
                    vehicle_owner:"",
                    vehicle_brand:"",
                    vehicle_color:"",
                    visa_required:"",
                    visa_invitation_letter:"",
                    visa_entity_issuer:"",
                    visa_period_from:"",
                    visa_period_to:"",
                    visa_city_country:"",
                    visa_invitation_reason:"",
                    ticket_required:"",
                    ticket_type:"",
                    ticket_validity_days:"",
                    ticket_date:"",
                    ticket_departure_city:"",
                    ticket_arrival_city:"",
                    ticket_class:"",
                    ticket_other_details:"",
                    lodging_required:"",
                    lodging_hotel:"",
                    rental_vehicle_required:"",
                    rental_company:"",
                    rental_vehicle_model:"",
                    budget_lodging:"",
                    budget_transport:"",
                    budget_per_diem:"",
                    budget_business_actions:"",
                    budget_other:"",
                    budget_currency:"",
                    budget_total:""
                }
            }
        },
        mounted(){
            this.getMotif();
        },
        methods:{
            cursorClick(){},
            pushdemande(){
                this.$router.push({path:"/my-demande"})
            },
            btnAction(type){
                if(type == "des" && this.step > 1){
                    this.step = this.step - 1
                }
                if(type == "asc" && this.step < 7){
                    this.step = this.step + 1
                }
            },
            getMotif(){
            API.get("/getTypesAndMotifs")
            .then((data)=>{
                this.type =  data.data["types"].filter((el)=> el["symbol"] == "s")[0]["id"]
                this.motif = data.data["motifs"].filter((el) => el.is_out_of_office == 1)[0]["id"]
            })
            .catch(e=>{console.log(e)})},
            submitRequest(){
                this.asSend = true;
                API.post("askForPermission",{...this.formdata,type_id:this.type,motif_id:this.motif})
                .then((res)=>{
                    if(!res.data.status) throw Error(res.data.message);
                    Swal.fire('Succès',"Le formulaire a été soummit",'succes');
                }).catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                .finally(()=>{this.asSend = false;});
            }
        }
    }
</script>